// extracted by mini-css-extract-plugin
export default {"header":"oV-z","logo":"pV-z","signin":"qV-z"};